import React from "react";
import {Card, Col, Row} from "antd";
import PropTypes from 'prop-types';

import '../../assets/less/Card.less';

const CarAccessoriesCard = ({car}) => {
    const {
        accessories
    } = car;

    const labelColSize = {
        xs: 24,
        md: 12
    };

    const dataColSize = {
        xs: 24,
        md: 12,
    };

    const accessoryNames = accessories.map(accessory => accessory.name).join(', ');

    return (
        <Card
            title="Others"
            bordered={true}
            className="details-card"
        >
            <Row>
                <Col {...labelColSize}>
                    <strong>Accessories:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">{accessoryNames || 'N/A'}</span>
                </Col>
            </Row>
        </Card>
    )
};

export default CarAccessoriesCard;

CarAccessoriesCard.propTypes = {
    car: PropTypes.shape({
        accessories: PropTypes.array.isRequired,
    }).isRequired,
};
